export enum ResponseStatus {
    Sucess = "success",
    Failure = "failure",
    Error = "error"
}

export interface IHttpClientData<T = any> {
    isUnauthorized: boolean;
    code: number | null;
    status: ResponseStatus | null;
    message: string | null;
    data: T | null;
}

export interface IApiRequest {
    [key: string]: any | null;
}

export interface IApiResponse {
    [key: string]: any | null;
}
